import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import XLSX from 'xlsx';

import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { toast } from 'react-toastify';

import { PageTitle, SimplePopup } from 'components';

import { DistributorToolbar, DistributorTable, RegisterDistributor } from './components';
import { CompanyToolbar, CompanyTable, RegisterCompany, UploadCompanyFile } from './components';
import { CarToolbar, CarTable, RegisterCar } from './components';
import { AgencyToolbar, AgencyTable, RegisterAgency } from './components';
import { ClientToolbar, ClientTable, RegisterClient } from './components';

import { IsNoU } from 'common/utils';

import serverURI from 'config/URI';

// >> redux
import {
  getDistributors,
  addDistributor,
  updateDistributor,
  deleteDistributor,

  findDistributors,
  removeDistributors,

  getCompanies,
  addCompany,
  updateCompany,
  deleteCompany,
  getCompanyNames,
  findCompanies,
  removeCompanies,

  getCars,
  addCar,
  updateCar,
  deleteCar,
  getCarNumbers,
  findCars,
  removeCars,

  getAgencies,
  addAgency,
  updateAgency,
  deleteAgency,
  findAgencies,
  removeAgencies,

  getClients,
  addClient,
  updateClient,
  deleteClient,
  findClients,
  removeClients,
} from '../../redux/actions/companies';
// <<


// >> redux
import {
  getAreas,
  getGroups,
} from 'redux/actions/manage';
// <<


import { statusContracts } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignCompanies: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Company = (props) => {
  const classes = useStyles();

  const { type } = props.match.params;

  const { 
    loading_find_distributor,
    distributors,
    distributor_total,

    loading_find_company,
    company_names,
    companies, 
    company_total,

    loading_find_car,
    car_numbers,
    cars, 
    car_total,

    loading_find_agency,
    reged_agencies,
    agencies, 
    agency_total,

    loading_find_client,
    reged_clients,
    clients, 
    client_total,

    areas, 
    groups, 
    loading 
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [modeRegisterDistributor, setModeRegisterDistributor] = useState(true);
  const [openRegisterDistributor, setOpenRegisterDistributor] = useState(false);
  const [disableEditDistributorButton, setDisableEditDistributorButton] = useState(true);
  const [disableDeleteDistributorButton, setDisableDeleteDistributorButton] = useState(true);

  const [editDistributor, setEditDistributor] = useState(null);
  const [selectedDistributors, setSelectedDistributors] = useState([]);

  const [selectedContract, setSelectedContract] = useState('');

  //const [findedDistributors, setFindedDistributors] = useState([]);
  const [find_distributor_data, set_find_distributor_data] = useState({});

  const handleSearchDistributors = (name) => {

    // if (IsNoU(name) || name.length <= 0)
    //   name = 'all';

    // const newFindDistributors = distributors.filter((distributor) => {
    //   // console.log(advertise);
    //   // console.log(advertise.name.indexOf(name));
    //   // console.log(advertise.distributor.indexOf(distributor));
    //   // console.log(advertise.client.indexOf(client));
    //   return (name === 'all' || distributor.name.indexOf(name) !== -1);
    // });

    // //console.log(newFindDistributors);

    // setFindedDistributors(newFindDistributors);

    let distributor_name = '';
    let distributor_contract = '';
    if (name.length > 0)
      distributor_name = name;
    if (selectedContract !== '전체')
      distributor_contract = selectedContract;

    setPage(0);

    let find_distributor_data = {
      name: distributor_name,
      contract : distributor_contract,
      page: page,
      rows_per_page: rowsPerPage,
    };
    set_find_distributor_data(find_distributor_data);

    props.findDistributors(find_distributor_data);
  }

  const handleClickOpenRegisterDistributor = () => {
    setEditDistributor(null);
    setModeRegisterDistributor(true);

    setOpenRegisterDistributor(true);
  }

  const handleClickOpenEditDistributor = () => {

    if (selectedDistributors.length !== 1){
      return ;
    }
    const id = selectedDistributors[0];
    const selectedDistributor = distributors.find(distributor => (distributor.id === id));

    //console.log(selectedDistributor);
    setEditDistributor(selectedDistributor);
    setModeRegisterDistributor(false);

    setOpenRegisterDistributor(true);
  }

  const handleClickCloseRegisterDistributor = () => {
    setOpenRegisterDistributor(false);
  }

  const handleClickSaveDistributor= (distributor) => {
    if (modeRegisterDistributor) {
      props.addDistributor(distributor);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterDistributor && selectedDistributors.length === 1)
    {
      props.updateDistributor(distributor.id, distributor);
    }
    else
    {
      
    }
    setOpenRegisterDistributor(false);
  }

  const [modeRegisterCompany, setModeRegisterCompany] = useState(true);
  const [openRegisterCompany, setOpenRegisterCompany] = useState(false);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [editCompany, setEditCompay] = useState(null);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const [find_company_data, set_find_company_data] = useState({});
  //const [findCompanies, setFindCompanies] = useState([]);

  const handleSearchCompanies = (name, area, group, contract, type) => {

    let company_name = '';
    let company_area = '';
    let company_group = '';
    let company_contract = '';
    let company_type = '';
    if (name.length > 0)
      company_name = name;
    if (area !== '전체')
      company_area = area;
    if (group !== '전체' && group.length > 0)
      company_group = group;
    if (contract !== '전체')
      company_contract = contract;
    if (type !== '전체')
      company_type = type;

    setPage(0);

    let find_company_data = {
      name: company_name,
      area : company_area,
      group : company_group,
      contract : company_contract,
      type : company_type,
      page: 0,
      rows_per_page: rowsPerPage,
    };
    set_find_company_data(find_company_data);

    props.findCompanies(find_company_data);
  }

  const handleClickOpenRegisterCompany = () => {
    setEditCompay(null);
    setModeRegisterCompany(true);

    setOpenRegisterCompany(true);
  }

  const handleClickOpenEditCompany = () => {

    if (selectedCompanies.length !== 1){
      return ;
    }
    const id = selectedCompanies[0];
    const selectedCompany = companies.find(company => (company.id === id));

    //console.log(selectedCompany);
    setEditCompay(selectedCompany);
    setModeRegisterCompany(false);

    setOpenRegisterCompany(true);
  }

  const handleClickCloseRegisterCompany = () => {
    setOpenRegisterCompany(false);
  }

  const handleClickSaveCompany = (company) => {
    if (modeRegisterCompany) {
      props.addCompany(company);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterCompany && selectedCompanies.length === 1)
    {
      props.updateCompany(company.id, company);
    }
    else
    {
      
    }
    setOpenRegisterCompany(false);
  }


  const [modeRegisterCar, setModeRegisterCar] = useState(true);
  const [openRegisterCar, setOpenRegisterCar] = useState(false);
  const [disableEditCarButton, setDisableEditCarButton] = useState(true);
  const [disableDeleteCarButton, setDisableDeleteCarButton] = useState(true);

  const [editCar, setEditCar] = useState(null);
  const [selectedCars, setSelectedCars] = useState([]);

  //const [findCars, setFindCars] = useState([]);
  const [find_car_data, set_find_car_data] = useState({});

  const handleSearchCars = (company, typeDevice, carNumber, startDate, endDate) => {

    let car_company = '';
    let car_device_status = '';
    let car_number = '';
    if (company.length > 0)
      car_company = company;
    if (typeDevice !== '전체')
      car_device_status = typeDevice;
    if (carNumber.length > 0)
      car_number = carNumber;

    setPage(0);

    let find_car_data = {
      company: car_company,
      device_status : car_device_status,
      number : car_number,
      page: 0,
      rows_per_page: rowsPerPage,
    };

    // let compare_date = new Date('2020-01-01');
    // if (compare_date.getTime() !== startDate.getTime() 
    //   && compare_date.getTime() !== endDate.getTime()) {
    if (!IsNoU(startDate) && !IsNoU(endDate)) {
      find_car_data.start_date = startDate;
      find_car_data.end_date = endDate;
    }

    set_find_car_data(find_car_data);

    props.findCars(find_car_data);
  }

  const handleClickOpenRegisterCar = () => {
    setEditCar(null);
    setModeRegisterCar(true);

    setOpenRegisterCar(true);
  }

  const handleClickOpenEditCar = () => {

    if (selectedCars.length !== 1){
      return ;
    }
    const id = selectedCars[0];
    const selectedCar = cars.find(car => (car.id === id));

    //console.log(selectedCar);
    setEditCar(selectedCar);
    setModeRegisterCar(false);

    setOpenRegisterCar(true);
  }

  const handleClickCloseRegisterCar = () => {
    setOpenRegisterCar(false);
  }

  const handleClickSaveCar = (car) => {
    if (modeRegisterCar) {
      props.addCar(car);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterCar && selectedCars.length === 1)
    {
      props.updateCar(car.id, car);
    }
    else
    {
      
    }
    setOpenRegisterCar(false);
  }


  const [modeRegisterAgency, setModeRegisterAgency] = useState(true);
  const [openRegisterAgency, setOpenRegisterAgency] = useState(false);
  const [disableEditAgencyButton, setDisableEditAgencyButton] = useState(true);
  const [disableDeleteAgencyButton, setDisableDeleteAgencyButton] = useState(true);

  const [editAgency, setEditAgency] = useState(null);
  const [selectedAgencies, setSelectedAgencies] = useState([]);

  //const [findedAgencies, setFindedAgencies] = useState([]);
  const [find_agency_data, set_find_agency_data] = useState({});

  const handleSearchAgencies = (name) => {

    let agency_name = '';
    if (name.length > 0)
      agency_name = name;

    setPage(0);

    let find_agency_data = {
      name: agency_name,
      page: 0,
      rows_per_page: rowsPerPage,
    };

    set_find_agency_data(find_agency_data);

    props.findAgencies(find_agency_data);

    // if (IsNoU(name) || name.length <= 0)
    //   name = 'all';

    // const newFindAgencies = agencies.filter((agency) => {
    //   // console.log(advertise);
    //   // console.log(advertise.name.indexOf(name));
    //   // console.log(advertise.agency.indexOf(agency));
    //   // console.log(advertise.client.indexOf(client));
    //   return (name === 'all' || agency.name.indexOf(name) !== -1);
    // });

    // //console.log(newFindAgencies);

    // setFindedAgencies(newFindAgencies);
  }

  const handleClickOpenRegisterAgency = () => {
    setEditAgency(null);
    setModeRegisterAgency(true);

    setOpenRegisterAgency(true);
  }

  const handleClickOpenEditAgency = () => {

    if (selectedAgencies.length !== 1){
      return ;
    }
    const id = selectedAgencies[0];
    const selectedAgency = agencies.find(agency => (agency.id === id));

    //console.log(selectedAgency);
    setEditAgency(selectedAgency);
    setModeRegisterAgency(false);

    setOpenRegisterAgency(true);
  }

  const handleClickCloseRegisterAgency = () => {
    setOpenRegisterAgency(false);
  }

  const handleClickSaveAgency= (agency) => {
    if (modeRegisterAgency) {
      props.addAgency(agency);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterAgency && selectedAgencies.length === 1)
    {
      props.updateAgency(agency.id, agency);
    }
    else
    {
      
    }
    setOpenRegisterAgency(false);
  }

  const [modeRegisterClient, setModeRegisterClient] = useState(true);
  const [openRegisterClient, setOpenRegisterClient] = useState(false);
  const [disableEditClientButton, setDisableEditClientButton] = useState(true);
  const [disableDeleteClientButton, setDisableDeleteClientButton] = useState(true);

  const [editClient, setEditClient] = useState(null);
  const [selectedClients, setSelectedClients] = useState([]);

  //const [findedClients, setFindedClients] = useState([]);
  const [find_client_data, set_find_client_data] = useState({});

  const handleSearchClients = (name, contract, startDate, endDate) => {

    let client_name = '';
    let client_contract = '';
    if (name.length > 0)
      client_name = name;
    if (contract !== '전체')
      client_contract = contract;

    setPage(0);

    let find_client_data = {
      name: client_name,
      contract : client_contract,
      page: 0,
      rows_per_page: rowsPerPage,
    };

    let compare_date = new Date('2020-01-01');
    if (compare_date.getTime() !== startDate.getTime() 
      && compare_date.getTime() !== endDate.getTime()) {
        find_client_data.start_date = startDate;
        find_client_data.end_date = endDate;
    }

    set_find_client_data(find_client_data);

    props.findClients(find_client_data);
  }

  const handleClickOpenRegisterClient = () => {

    if (IsNoU(reged_agencies) || reged_agencies.length <= 0) {
      toast("광고대행사 사항이 없습니다. 광고대행사를 먼저 입력하세요.");
      return ;
    }

    setEditClient(null);
    setModeRegisterClient(true);

    setOpenRegisterClient(true);
  }

  const handleClickOpenEditClient = () => {

    if (selectedClients.length !== 1){
      return ;
    }
    const id = selectedClients[0];
    const selectedClient = clients.find(client => (client.id === id));

    //console.log(selectedClient);
    setEditClient(selectedClient);
    setModeRegisterClient(false);

    setOpenRegisterClient(true);
  }

  const handleClickCloseRegisterClient = () => {
    setOpenRegisterClient(false);
  }

  const handleClickSaveClient= (client) => {
    if (modeRegisterClient) {
      props.addClient(client);
      setPage(0);
      setRowsPerPage(10);
    }
    else if (!modeRegisterClient && selectedClients.length === 1)
    {
      props.updateClient(client.id, client);
    }
    else
    {
      
    }
    setOpenRegisterClient(false);
  }

  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const handleClickOpenDelete = () => {
    if (type === 'distributor') {
      if (selectedDistributors.length === 0){
        return ;
      }
    }
    else if (type === 'taxi') {
      if (selectedCompanies.length === 0){
        return ;
      }
    }
    else if (type === 'cars') {
      if (selectedCars.length === 0){
        return ;
      }
    }
    else if (type === 'aency') {
      if (selectedAgencies.length === 0){
        return ;
      }
    }
    else if (type === 'client') {
      if (selectedClients.length === 0){
        return ;
      }
    }
    setOpenDeleteAlert(true);
  };

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    //console.log('handleClickDeleteAlertOk -> ' + selectedTemplates.length);
    if (type === 'distributor') {
      if (selectedDistributors.length === 0){
        return ;
      }
    }
    else if (type === 'taxi') {
      if (selectedCompanies.length === 0){
        return ;
      }
    }
    else if (type === 'cars') {
      if (selectedCars.length === 0){
        return ;
      }
    }
    else if (type === 'agency') {
      if (selectedAgencies.length === 0){
        return ;
      }
    }
    else if (type === 'client') {
      if (selectedClients.length === 0){
        return ;
      }
    }

    let deletes;
    if (type === 'distributor') {
      deletes = selectedDistributors.map((selected)=>{
        return distributors.find(distributor => (distributor.id === selected));
      });
      props.deleteDistributor(deletes);
    }
    else if (type === 'taxi') {
      deletes = selectedCompanies.map((selected)=>{
        return companies.find(company => (company.id === selected));
      });
      props.deleteCompany(deletes);
    }
    else if (type === 'cars') {
      deletes = selectedCars.map((selected)=>{
        return cars.find(car => (car.id === selected));
      });
      props.deleteCar(deletes);
    }
    else if (type === 'agency') {
      deletes = selectedAgencies.map((selected)=>{
        return agencies.find(agency => (agency.id === selected));
      });
      props.deleteAgency(deletes);
    }
    else if (type === 'client') {
      deletes = selectedClients.map((selected)=>{
        return clients.find(client => (client.id === selected));
      });
      props.deleteClient(deletes);
    }
    
    setOpenDeleteAlert(false);
  }

  const [openUploadDialog, setOpenUploadDialog] = useState(false);

  const handleClickOpenUpload = () => {
    setOpenUploadDialog(true);
  };

  const handleDownloadCompanyFile = async () => {

    const res = await axios.post(`${serverURI}/api/company/taxi/download`, find_company_data);
    console.log(res);
    const companies = res.data.companies;

    const company_datas = companies.map(company => {
      return {
        '회사명' : company.name, 
        '권역' : company.area, 
        '그룹' : company.group, 
        '계약상태' : company.contract,
        '사업장구분' : company.type,
        '거래담당자' : company.manager,
        '전화번호' : company.tel,
        '핸드폰' : company.mobile,
        '메일' : company.email,
        '우편번호' : company.zipcode,
        '주소1' : company.address1,
        '주소2' : company.address2,
      }
    });

    var wscols = [
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:20},
      {wch:20},
      {wch:30},
      {wch:20},
      {wch:24},
      {wch:24}
    ];
  
    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(company_datas); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;


    XLSX.utils.book_append_sheet(new_workbook, worksheet, '택시회사정보'); // excelsheet를 excel파일에 넣음 
    //worksheet.getCell('A1').alignment = {vertical:'middle', horizontal:'center'};
    const dateNow = new Date();
    const fileName = `report_company_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    XLSX.writeFile(new_workbook, fileName + '.xlsx');

  }

  const handleDownloadCarFile = async () => {

    const res = await axios.post(`${serverURI}/api/company/car/download`, find_car_data);
    console.log(res);
    const cars = res.data.cars;

    const car_datas = cars.map(car => {
      return {
        '차량번호' : car.number, 
        '택시회사명' : car.company, 
        '차종' : car.type, 
        '연식' : car.year,
        '대리점명' : car.distributor,
      }
    });

    var wscols = [
      {wch:20},
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:20},
    ];
  
    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(car_datas); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;


    XLSX.utils.book_append_sheet(new_workbook, worksheet, '차량정보'); // excelsheet를 excel파일에 넣음 
    //worksheet.getCell('A1').alignment = {vertical:'middle', horizontal:'center'};
    const dateNow = new Date();
    const fileName = `report_car_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    XLSX.writeFile(new_workbook, fileName + '.xlsx');
  }

  const handleClickOpenDownload = () => {
    if (type === 'taxi') {
      if (companies.length === 0) {
        toast('검색된 택시회사 정보가 없습니다.');
        return ;
      }

      handleDownloadCompanyFile();
    }
    else if (type === 'cars') {
      if (cars.length == 0){
        toast('검색된 차량 정보가 없습니다.');
        return ;
      }

      handleDownloadCarFile();
    }
    // if (type === 'taxi') {
    //   if (selectedCompanies.length == 0){
    //     return ;
    //   }
    // }
    // else if (type === 'cars') {
    //   if (selectedCars.length == 0){
    //     return ;
    //   }
    // }
    // else if (type === 'aency') {
    //   if (selectedAgencies.length == 0){
    //     return ;
    //   }
    // }
    // else if (type === 'client') {
    //   if (selectedClients.length == 0){
    //     return ;
    //   }
    // }
    //setOpenUploadDialog(true);
  };

  const handleClickCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  }
  
  const handleClickUploadFile = () => {
    
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    //console.log('change page -> ' + page);
    setPage(page);
    if (type === 'distributor') {
      let find_page_data = {
        name: find_distributor_data.name,
        page: page,
        rows_per_page: rowsPerPage,
      };
      set_find_distributor_data(find_page_data);

      props.findDistributors(find_page_data);
    }
    else if (type === 'taxi') {
      let find_page_data = {
        name: find_company_data.name,
        page: page,
        rows_per_page: rowsPerPage,
      };
      set_find_company_data(find_page_data);

      props.findCompanies(find_page_data);
    }
    else if (type === 'cars') {
      let find_page_data = {
        company: find_car_data.company,
        type : find_car_data.type,
        number : find_car_data.number,
        page: page,
        rows_per_page: rowsPerPage,
      };
  
      if (find_page_data.start_date) find_page_data.start_date = find_car_data.start_date;
      if (find_page_data.end_date) find_page_data.end_date = find_car_data.end_date;
  
      set_find_car_data(find_page_data);
  
      props.findCars(find_page_data);
    }
    else if (type === 'agency') {
      let find_page_data = {
        name: find_agency_data.name,
        page: page,
        rows_per_page: rowsPerPage,
      };
  
      set_find_agency_data(find_page_data);
  
      props.findAgencies(find_page_data);
    }
    else if (type === 'client') {
      let find_page_data = {
        name: find_car_data.name,
        contract : find_car_data.contract,
        page: page,
        rows_per_page: rowsPerPage,
      };
  
      if (find_page_data.start_date) find_page_data.start_date = find_car_data.start_date;
      if (find_page_data.end_date) find_page_data.end_date = find_car_data.end_date;
  
      props.findClients(find_page_data);
    }
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);
    if (type === 'distributor') {
      let find_page_data = {
        name: find_distributor_data.name,
        page: 0,
        rows_per_page: rows_per_page,
      };
      set_find_distributor_data(find_page_data);

      props.findDistributors(find_page_data);
    }
    else if (type === 'taxi') {
      let find_page_data = {
        name: find_company_data.name,
        page: 0,
        rows_per_page: rows_per_page,
      };
      set_find_company_data(find_page_data);

      props.findCompanies(find_page_data);
    }
    else if (type === 'cars') {
      let find_page_data = {
        company: find_car_data.company,
        type : find_car_data.type,
        number : find_car_data.number,
        page: 0,
        rows_per_page: rows_per_page,
      };
  
      if (find_car_data.start_date) find_page_data.start_date = find_car_data.start_date;
      if (find_car_data.end_date) find_page_data.end_date = find_car_data.end_date;
  
      set_find_car_data(find_car_data);
  
      props.findCars(find_car_data);
    }
    else if (type === 'agency') {
      let find_page_data = {
        name: find_agency_data.name,
        page: 0,
        rows_per_page: rows_per_page,
      };
  
      set_find_agency_data(find_page_data);
  
      props.findAgencies(find_page_data);
    }
    else if (type === 'client') {
      let find_page_data = {
        name: find_car_data.name,
        contract : find_car_data.contract,
        page: 0,
        rows_per_page: rowsPerPage,
      };
  
      if (find_car_data.start_date) find_page_data.start_date = find_car_data.start_date;
      if (find_car_data.end_date) find_page_data.end_date = find_car_data.end_date;
  
      props.findClients(find_page_data);
    }
  };

  useEffect(() => {
    //console.log("componentDidMount");

    props.getAreas();
    props.getGroups();

    //props.getDistributors();
    //if (type === 'taxi')
      //props.getCompanies();
    //else if (type === 'cars')
      //props.getCars();
    //else if (type === 'agency')
      props.getAgencies();
    //else if (type === 'client')
      props.getClients();

    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    return () => {
      //console.log("componentDidUnmount");
      props.removeDistributors();
      props.removeCompanies();
      props.removeCars();
      props.removeAgencies();
      props.removeClients();
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');

    if (type !== 'distributor') props.removeDistributors();
    if (type !== 'taxi') props.removeCompanies();
    if (type !== 'cars') props.removeCars();
    if (type !== 'agency') props.removeAgencies();
    if (type !== 'client') props.removeClients();

    if (type === 'taxi' || type === 'cars') {
      props.getCompanyNames();
    }
    if (type === 'cars') {
      props.getCarNumbers();
      props.getDistributors();
    }
 
    // if (type === 'taxi')
    //   props.getCompanies();
    // else if (type === 'cars') {
    //   props.getDistributors();
    //   props.getCars();
    // }
    if (type === 'agency')
      props.getAgencies();
    // else if (type === 'client')
    //   props.getClients();

  }, [type]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditDistributorButton(selectedDistributors.length != 1);
    setDisableDeleteDistributorButton(selectedDistributors.length < 1);

  }, [selectedDistributors]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditButton(selectedCompanies.length != 1);
    setDisableDeleteButton(selectedCompanies.length < 1);

  }, [selectedCompanies]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditCarButton(selectedCars.length != 1);
    setDisableDeleteCarButton(selectedCars.length < 1);

  }, [selectedCars]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditAgencyButton(selectedAgencies.length != 1);
    setDisableDeleteAgencyButton(selectedAgencies.length < 1);

  }, [selectedAgencies]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditClientButton(selectedClients.length != 1);
    setDisableDeleteClientButton(selectedClients.length < 1);

  }, [selectedClients]);

  // useEffect(() => {
  //   //console.log("componentDidUpdate & distributors changed");
  //   if (!IsNoU(distributors) && distributors.length > 0) {
  //     setFindedDistributors(distributors);
  //   }
  //   else {
  //     setFindedDistributors([]);
  //   }
  // }, [distributors]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   //console.log("componentDidUpdate & companies changed");
  //   if (!IsNoU(companies) && companies.length > 0) {
  //     setFindCompanies(companies);
  //   }
  //   else {
  //     setFindCompanies([]);
  //   }
  // }, [companies]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   //console.log("componentDidUpdate & cars changed");
  //   if (!IsNoU(cars) && cars.length > 0) {
  //     setFindCars(cars);
  //   }
  //   else {
  //     setFindCars([]);
  //   }
  // }, [cars]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   //console.log("componentDidUpdate & cars changed");
  //   if (!IsNoU(agencies) && agencies.length > 0) {
  //     setFindedAgencies(agencies);
  //   }
  //   else {
  //     setFindedAgencies([]);
  //   }
  // }, [agencies]); // empty-array means don't watch for any updates


  // useEffect(() => {
  //   //console.log("componentDidUpdate & cars changed");
  //   if (!IsNoU(clients) && clients.length > 0) {
  //     setFindedClients(clients);
  //   }
  //   else {
  //     setFindedClients([]);
  //   }
  // }, [clients]); // empty-array means don't watch for any updates

  if (loading) {
    return <WaveLoading />;
  }
  
  return (
    <div className={classes.root}>
      {/* <AdvertiseToolbar /> */}

      {type !== 'taxi' && 
      type !== 'cars' && 
      type !== 'agency' && 
      type !== 'client' && 
      type !== 'distributor' && <Redirect to="/not-found"/>}

      <PageTitle
        pageTitle={type === 'distributor'? '대리점관리' : 
          type === 'taxi'? '택시회사관리' : 
          type === 'cars'? '차량관리' : 
          type === 'agency'? '광고대행사관리' : 
          '광고주관리'}
        />

      {type === 'distributor' && (
        <div>
          <DistributorToolbar
            onClickSearch={handleSearchDistributors}
            contracts={[{value:-1, label: '전체'}, ...statusContracts]}
            valueContract={selectedContract}
            onChangeContract={e => setSelectedContract(e.target.value)}
            />

          <div className={classes.content}>
            <DistributorTable 
              userRole={userRole}
              distributors={distributors}
              onSetSelectedDistributors={(checks) => {setSelectedDistributors(checks)}}
              onClickOpenRegister={handleClickOpenRegisterDistributor}
              onClickOpenEdit={handleClickOpenEditDistributor}
              onClickOpenDelete={handleClickOpenDelete}
              disableEditButton={disableEditDistributorButton}
              disableDeleteButton={disableDeleteDistributorButton}

              openProgress={loading_find_distributor}
              page={page}
              rowsPerPage={rowsPerPage}
              item_total={distributor_total}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              />
          </div>

          <RegisterDistributor
            openDialog = {openRegisterDistributor}
            modeRegisterDialog = {modeRegisterDistributor}
            onClickCloseDialog = {handleClickCloseRegisterDistributor}
            onClickSaveDialog = {handleClickSaveDistributor}
            editDistributor = {editDistributor}
            />
        </div>
      )}

      {type === 'taxi' && (
        <div>
          <CompanyToolbar 
            userRole={userRole}
            companies={company_names}
            areas={[{id:-1, name: '전체'}, ...areas]}
            groups={[{id:-1, name: '전체'}, ...groups]}
            onClickSearch={handleSearchCompanies}
            onClickOpenRegisterDialog={handleClickOpenRegisterCompany}
            onClickOpenEditDialog={handleClickOpenEditCompany}
            onClickOpenDeleteDialog={handleClickOpenDelete}
            disableEditButton={disableEditButton}
            disableDeleteButton={disableDeleteButton}
            onClickOpenUploadDialog={handleClickOpenUpload}
            onClickOpenDownloadDialog={handleClickOpenDownload}
            />

          <div className={classes.content}>
            <CompanyTable 
              companies={companies}
              onSetSelectedCompanies={(checks) => {setSelectedCompanies(checks)}}

              openProgress={loading_find_company}
              page={page}
              rowsPerPage={rowsPerPage}
              item_total={company_total}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              />
          </div>

          <RegisterCompany
            openDialog = {openRegisterCompany}
            modeRegisterDialog = {modeRegisterCompany}
            onClickCloseDialog = {handleClickCloseRegisterCompany}
            onClickSaveDialog = {handleClickSaveCompany}

            areas={areas}
            groups={groups}
            editCompany = {editCompany}
              />
        </div>
      )}

      {type === 'cars' && (
        <div>
          <CarToolbar 
            companies={company_names}
            cars={car_numbers}
            onClickSearch={handleSearchCars}
            />

          <div className={classes.content}>
            <CarTable 
              userRole={userRole}
              cars={cars}
              onSetSelectedCars={(checks) => {setSelectedCars(checks)}}
              onClickOpenRegister={handleClickOpenRegisterCar}
              onClickOpenEdit={handleClickOpenEditCar}
              onClickOpenDelete={handleClickOpenDelete}
              disableEditButton={disableEditCarButton}
              disableDeleteButton={disableDeleteCarButton}

              onClickOpenUploadDialog={handleClickOpenUpload}
              onClickOpenDownloadDialog={handleClickOpenDownload}

              openProgress={loading_find_car}
              page={page}
              rowsPerPage={rowsPerPage}
              item_total={car_total}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              />
          </div>

          <RegisterCar
            openDialog = {openRegisterCar}
            modeRegisterDialog = {modeRegisterCar}
            onClickCloseDialog = {handleClickCloseRegisterCar}
            onClickSaveDialog = {handleClickSaveCar}
            distributors = {distributors}
            companies = {company_names}
            editCar = {editCar}
            />
        </div>
      )}
      
      {type === 'agency' &&
        (
          <div>
            <AgencyToolbar 
              onClickSearch={handleSearchAgencies}
              />

            <div className={classes.content}>
              <AgencyTable 
                userRole={userRole}
                agencies={agencies}
                onSetSelectedAgencies={(checks) => {setSelectedAgencies(checks)}}
                onClickOpenRegister={handleClickOpenRegisterAgency}
                onClickOpenEdit={handleClickOpenEditAgency}
                onClickOpenDelete={handleClickOpenDelete}
                disableEditButton={disableEditAgencyButton}
                disableDeleteButton={disableDeleteAgencyButton}

                openProgress={loading_find_agency}
                page={page}
                rowsPerPage={rowsPerPage}
                item_total={agency_total}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                />
            </div>

            <RegisterAgency
              openDialog = {openRegisterAgency}
              modeRegisterDialog = {modeRegisterAgency}
              onClickCloseDialog = {handleClickCloseRegisterAgency}
              onClickSaveDialog = {handleClickSaveAgency}
              agencies = {reged_agencies}
              editAgency = {editAgency}
              />
          </div>
        )
      }

      {type === 'client' &&
        (
          <div>
            <ClientToolbar 
              onClickSearch={handleSearchClients}
              contracts={[{value:-1, label: '전체'}, ...statusContracts]}
              valueContract={selectedContract}
              onChangeContract={e => setSelectedContract(e.target.value)}
              />

            <div className={classes.content}>
              <ClientTable 
                userRole={userRole}
                clients={clients}
                onSetSelectedClients={(checks) => {setSelectedClients(checks)}}
                onClickOpenRegister={handleClickOpenRegisterClient}
                onClickOpenEdit={handleClickOpenEditClient}
                onClickOpenDelete={handleClickOpenDelete}
                disableEditButton={disableEditClientButton}
                disableDeleteButton={disableDeleteClientButton}

                openProgress={loading_find_client}
                page={page}
                rowsPerPage={rowsPerPage}
                item_total={client_total}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                />
            </div>

            <RegisterClient
              openDialog = {openRegisterClient}
              modeRegisterDialog = {modeRegisterClient}
              onClickCloseDialog = {handleClickCloseRegisterClient}
              onClickSaveDialog = {handleClickSaveClient}
              agencies = {reged_agencies}
              editClient = {editClient}
              />
          </div>
        )
      }

      <UploadCompanyFile
        type={type}
        openDialog={openUploadDialog}
        onClickCloseDialog={handleClickCloseUploadDialog}
        // onClickUploadFile={handleClickUploadFile}
        // onClickDownloadFile={handleClickFromDownload}
        />

      <SimplePopup
        title={`선택한 데이터를 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />

    </div>
  );
};

//export default Company;


Company.propTypes = {
  loading: PropTypes.bool,

  distributors: PropTypes.arrayOf(PropTypes.object),
  companies: PropTypes.arrayOf(PropTypes.object),
  cars: PropTypes.arrayOf(PropTypes.object),
  agencies: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),

  areas: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
};

Company.defaultProps = {
  loading: false,

  distributors: [],
  companies: [],
  cars: [],
  agencies: [],
  clients: [],

  areas: [],
  groups: [],
};

const mapStateToProps = state => ({
  loading: state.companies.loading,

  loading_find_distributor: state.companies.find_distributor_loading,
  distributors: state.companies.distributorList,
  distributor_total: state.companies.distributor_total,

  loading_find_company: state.companies.find_company_loading,
  company_names: state.companies.companyNameList,
  companies: state.companies.companyList,
  company_total: state.companies.company_total,

  loading_find_car : state.companies.find_car_loading,
  car_numbers: state.companies.carNumberList,
  cars: state.companies.carList,
  car_total: state.companies.car_total,

  loading_find_agency : state.companies.find_agency_loading,
  reged_agencies: state.companies.reged_agencyList,
  agencies: state.companies.agencyList,
  agency_total: state.companies.agency_total,

  loading_find_client : state.companies.find_client_loading,
  reged_clients: state.companies.reged_clientList,
  clients: state.companies.clientList,
  client_total: state.companies.client_total,

  areas: state.manage.reged_areaList,
  groups: state.manage.groupList,
});

const mapDispatchToProps = dispatch => ({
  getDistributors: () => {getDistributors(dispatch)},
  addDistributor: (agency) => {addDistributor(agency, dispatch)},
  updateDistributor: (id, agency) => {updateDistributor(id, agency, dispatch)},
  deleteDistributor: (deletes) => {deleteDistributor(deletes, dispatch)},
  findDistributors: (find) => {findDistributors(find, dispatch)},
  removeDistributors: () => {removeDistributors(dispatch)},

  getCompanies: () => {getCompanies(dispatch)},
  addCompany: (company) => {addCompany(company, dispatch)},
  updateCompany: (id, company) => {updateCompany(id, company, dispatch)},
  deleteCompany: (deletes) => {deleteCompany(deletes, dispatch)},
  getCompanyNames: () => {getCompanyNames(dispatch)},
  findCompanies: (find) => {findCompanies(find, dispatch)},
  removeCompanies: () => {removeCompanies(dispatch)},

  getCars: () => {getCars(dispatch)},
  addCar: (car) => {addCar(car, dispatch)},
  updateCar: (id, car) => {updateCar(id, car, dispatch)},
  deleteCar: (deletes) => {deleteCar(deletes, dispatch)},
  getCarNumbers: () => {getCarNumbers(dispatch)},
  findCars: (find) => {findCars(find, dispatch)},
  removeCars: () => {removeCars(dispatch)},

  getAgencies: () => {getAgencies(dispatch)},
  addAgency: (agency) => {addAgency(agency, dispatch)},
  updateAgency: (id, agency) => {updateAgency(id, agency, dispatch)},
  deleteAgency: (deletes) => {deleteAgency(deletes, dispatch)},
  findAgencies: (find) => {findAgencies(find, dispatch)},
  removeAgencies: () => {removeAgencies(dispatch)},

  getClients: () => {getClients(dispatch)},
  addClient: (client) => {addClient(client, dispatch)},
  updateClient: (id, client) => {updateClient(id, client, dispatch)},
  deleteClient: (deletes) => {deleteClient(deletes, dispatch)},
  findClients: (find) => {findClients(find, dispatch)},
  removeClients: () => {removeClients(dispatch)},

  getAreas: () => {getAreas(dispatch)},
  getGroups: () => {getGroups(dispatch)},  
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Company);

